import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { MaestroModel } from '../maestro.model';
import { ConceptoService } from '../../services/tesoreria/concepto.service';


export class Concepto extends MaestroModel {

    public static RECORD_NAME = 'conceptos';
    public static CODIGO_REGISTRO = 'concepto';
    public static CODIGO_MODULO = 'tesoreria';
    public static NOMBRE_SINGULAR = 'Concepto';
    public static NOMBRE_PLURAL = 'Conceptos';

    public static INGRESO = 1;
    public static EGRESO = 2;
    public static SALDO = 3;
    public static VALORES = 4;

    public static TIPOS = [
        { valor: 1, nombre: 'Ingreso' },
        { valor: 2, nombre: 'Egreso' },
        { valor: 3, nombre: 'Saldo' },
        { valor: 4, nombre: 'Valores' },
    ]

    public static USO_CAJA = 1;
    public static USO_GERENCIA = 2;

    public static USOS = [
        { valor: 1, nombre: 'Caja' },
        { valor: 2, nombre: 'Gerencia' },
    ]

    public static NIVEL_PRINCIPAL = 1;
    public static NIVEL_SECUNDARIO = 2;

    public static NIVELES = [
        { valor: 1, nombre: 'Principal' },
        { valor: 2, nombre: 'Secundario' },
    ]

    private _idEmpresa: number;
    private _nombreEmpresa: string;
    private _codigo: string;
    private _tipo: number;
    private _ingresos: string;
    private _egresos: string;
    private _nivel: number;
    private _uso: number;
    private _idConceptoPrincipal: number;
    private _codigoConceptoPrincipal: string;
    private _nombreConceptoPrincipal: string;
    private _obligarConceptoSecundario: boolean;


    constructor() {
        super();
        this._idEmpresa = this.seguridad.getCurrentUser()?.id_empresa;
        this._nombreEmpresa = this.seguridad.getCurrentUser()?.nombre_empresa;
        this._tipo = Concepto.INGRESO;
        this._uso = Concepto.USO_CAJA;
        this._nivel = Concepto.NIVEL_PRINCIPAL;
        this._obligarConceptoSecundario = false;
    }

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa };
    public get nombreEmpresa(): string { return this._nombreEmpresa };

    public set codigo( codigo: string ) { this._codigo = codigo };
    public get codigo(): string { return this._codigo };

    public set ingresos( ingresos: string ) { this._ingresos = ingresos };
    public get ingresos(): string { return this._ingresos };

    public set uso( uso: number ) { this._uso = uso };
    public get uso(): number { return this._uso };

    public set nivel( nivel: number ) { this._nivel = nivel };
    public get nivel(): number { return this._nivel };

    public set idConceptoPrincipal( idConceptoPrincipal: number ) { this._idConceptoPrincipal = idConceptoPrincipal };
    public get idConceptoPrincipal(): number { return this._idConceptoPrincipal };

    public set codigoConceptoPrincipal( codigoConceptoPrincipal: string ) { this._codigoConceptoPrincipal = codigoConceptoPrincipal };
    public get codigoConceptoPrincipal(): string { return this._codigoConceptoPrincipal };

    public set nombreConceptoPrincipal( nombreConceptoPrincipal: string ) { this._nombreConceptoPrincipal = nombreConceptoPrincipal };
    public get nombreConceptoPrincipal(): string { return this._nombreConceptoPrincipal };

    public set obligarConceptoSecundario( obligarConceptoSecundario: boolean ) { this._obligarConceptoSecundario = obligarConceptoSecundario };
    public get obligarConceptoSecundario(): boolean { return this._obligarConceptoSecundario };


    public set serverJson( objeto: Record<string, any> ) { super.serverJson = objeto };

    public get serverJson(): Record<string, any> {
        const objeto = Object.assign({}, super.serverJson);
        const ingresos = objeto.ingresos ? objeto.ingresos.toString() : null;
        objeto.ingresos = ingresos;
        const egresos = objeto.egresos ? objeto.egresos.toString() : null;
        objeto.egresos = egresos;
        return objeto;
    };

    public static get columsOnLista(): Record<string, any>[] {
        return [
            // { field: 'id', label: 'ID', type: 'id' },
            { field: 'codigo', label: 'Codigo', type: 'text' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'tipo', label: 'Tipo', type: 'multiselect', options: Concepto.TIPOS },
            { field: 'uso', label: 'Uso', type: 'multiselect', options: Concepto.USOS },
        ]
    }

    async cargarDatos( objeto: Record<string, any> ) {
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._codigo = objeto.codigo;
        this._tipo = objeto.tipo;
        this._uso = objeto.uso;
        this._nivel = objeto.nivel;
        this._idConceptoPrincipal = objeto.id_concepto_principal;
        this._codigoConceptoPrincipal = objeto.concepto_concepto_principal;
        this._nombreConceptoPrincipal = objeto.nombre_concepto_principal;
        this._obligarConceptoSecundario = objeto.obligar_concepto_secundario;
        this._ingresos = objeto.ingresos;
        this._egresos = objeto.egresos;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );
    }

    async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa));
        fg.addControl("codigo", new FormControl(this._codigo));
        fg.addControl("tipo", new FormControl(this._tipo));
        fg.addControl("uso", new FormControl(this._uso));
        fg.addControl("nivel", new FormControl(this._nivel));
        fg.addControl("id_concepto_principal", new FormControl(this._idConceptoPrincipal));
        fg.addControl("codigo_concepto_principal", new FormControl(this._codigoConceptoPrincipal));
        fg.addControl("nombre_concepto_principal", new FormControl(this._nombreConceptoPrincipal));
        fg.addControl("obligar_concepto_secundario", new FormControl(this._obligarConceptoSecundario));
        fg.addControl("ingresos", new FormControl(this._ingresos ? this._ingresos.split(",").map( val => Number(val) ) : null ));
        fg.addControl("egresos", new FormControl(this._egresos ? this._egresos.split(",").map( val => Number(val) ) : null ));
        return fg;
    }
    

    async guardar( service: ConceptoService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    async actualizar( service: ConceptoService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    async eliminar( service: ConceptoService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}